import {ObjectUtil} from "../../../js/util/ObjectUtil";
import {StringKeyed} from "../../../types/GenericTypes";

export interface StrategyColumnDef {
    readonly name: string;
    readonly description: string;
    visible: boolean;
}

export interface StrategyColumnConfig {
    spc: StrategyColumnDef;
    vol: StrategyColumnDef;
    delta: StrategyColumnDef;
    gamma: StrategyColumnDef;
    vega: StrategyColumnDef;
    rho: StrategyColumnDef;
    dollarDelta: StrategyColumnDef;
    intrinsicValue: StrategyColumnDef;
}

export interface StrategyColumnPreset {
    readonly icon: string;
    readonly columns: StrategyColumnConfig;
}

export interface StrategyColumnPresets {
    readonly desktop: StrategyColumnPreset;
    readonly mobile: StrategyColumnPreset;
    readonly tablet: StrategyColumnPreset;
}

export function strategyColumns(terms: StringKeyed<any>): StrategyColumnConfig {
    return {
        spc: {
            name: "SPC",
            description: terms.CVF.description,
            visible: false
        },
        vol: {
            name: "Vol",
            description: terms.vol.description,
            visible: false
        },
        delta: {
            name: "Delta",
            description: terms.delta.description,
            visible: false
        },
        gamma: {
            name: "Gamma",
            description: terms.gamma.description,
            visible: false
        },
        vega: {
            name: "Vega",
            description: terms.vega.description,
            visible: false
        },
        rho: {
            name: "Rho",
            description: terms.rho.description,
            visible: false
        },
        dollarDelta: {
            name: "$ Delta",
            description: "",
            visible: false
        },
        intrinsicValue: {
            name: "Intrinsic Value",
            description: terms.intrinsic.description,
            visible: false
        }
    }
}

function desktopColumns(terms: StringKeyed<any>) {
    return ObjectUtil.merge({}, strategyColumns(terms), {
        spc: {
            visible: true
        },
        vol: {
            visible: true
        },
        delta: {
            visible: true
        },
        gamma: {
            visible: false
        },
        vega: {
            visible: false
        },
        rho: {
            visible: false
        },
        dollarDelta: {
            visible: false
        },
        intrinsicValue: {
            visible: false
        }
    });
}

function tabletColumns(terms: StringKeyed<any>) {

    return ObjectUtil.merge({}, strategyColumns(terms), {
        spc: {
            visible: false
        },
        vol: {
            visible: true
        },
        delta: {
            visible: true
        },
        gamma: {
            visible: false
        },
        vega: {
            visible: false
        },
        rho: {
            visible: false
        },
        dollarDelta: {
            visible: false
        },
        intrinsicValue: {
            visible: false
        }
    });
}

function mobileColumns(terms: StringKeyed<any>) {
    return ObjectUtil.merge({}, strategyColumns(terms), {
        spc: {
            visible: false
        },
        vol: {
            visible: false
        },
        delta: {
            visible: false
        },
        gamma: {
            visible: false
        },
        vega: {
            visible: false
        },
        rho: {
            visible: false
        },
        dollarDelta: {
            visible: false
        },
        intrinsicValue: {
            visible: false
        }
    });
}

export function strategyColumnPresets(terms: StringKeyed<any>): StrategyColumnPresets {
    return {
        desktop: {
            icon: "icon-desktop",
            columns: desktopColumns(terms)
        },
        tablet: {
            icon: "icon-tablet",
            columns: tabletColumns(terms)
        },
        mobile: {
            icon: "icon-phone2",
            columns: mobileColumns(terms)
        }
    }
}
